import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useHistory, useLocation } from 'react-router-dom';

import { ROUTE_TEMPLATES } from '../constants/routes';
import { selectInitKeys, selectIsInitialized } from '../store/selectors/keys';
import { INavigationState } from '../types/navigation';
import { buildPath } from '../util/buildPath';

const useKeepUrlParams = (): void => {
  const keys = useSelector(selectInitKeys);
  const history = useHistory();
  const { state, pathname } = useLocation<INavigationState>();
  const isInitialized = useSelector(selectIsInitialized);

  useEffect(() => {
    if (!isInitialized) {
      return;
    }

    if (!keys || Object.keys(keys).length === 0) {
      return;
    }

    const currentStep = pathname.split('/').at(-1);

    if (keys.one_link_id) {
      const path = buildPath(ROUTE_TEMPLATES.ONE_LINK, {
        oneLinkId: keys.one_link_id,
        step: currentStep || undefined,
      });
      history.replace(path, { ...state });
    } else if (keys.order_id && keys.key) {
      const path = generatePath(ROUTE_TEMPLATES.SEND, {
        orderId: keys.order_id,
        key: keys.key,
        step: currentStep || undefined,
      });
      history.replace(path, { ...state });
    }
  }, [keys, pathname, history, isInitialized]);
};

export default useKeepUrlParams;
